import { render } from "./SwapsFilters.vue?vue&type=template&id=7c6a65de"
import script from "./SwapsFilters.vue?vue&type=script&lang=js"
export * from "./SwapsFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__